import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import { useAppDispatch } from "../Core/store.hooks";
import { getRunningPeriodsOptionsSelector, nextBucket, previousBucket } from "./runningPeriodsOptionSlice";

interface RunningPeriodChartOptionProps{
    id:string
}

const RunningPeriodChartOptions = (props:RunningPeriodChartOptionProps) =>{
    const [bucketSize, updateBucketSize] = useState("");
    //const options = useSelector(getRunningPeriodsOptionsSelector)
    const params = useSelector(getParamsSelector)
    const dispatch = useAppDispatch()

    useEffect(()=>{
        
        if(params.bucketSize === "y"){
            updateBucketSize("Year")
        }
        if(params.bucketSize === "M"){
            updateBucketSize("Month")
        }
        if(params.bucketSize === "w"){
            updateBucketSize("Week")
        }
        if(params.bucketSize === "d"){
            updateBucketSize("Day")
        }
    },[params.bucketSize])

    const previousButtonHandler = () =>{
        dispatch(previousBucket())
    }

    const nextButtonHandler = () =>{
        dispatch(nextBucket())
    }

    return (
        <div className="ppFilterHeaderContainer">
            <Button onClick={previousButtonHandler} style={{width:"50%",whiteSpace:"normal", margin:"4px"}}>
                Previous <br/> {bucketSize}
            </Button>
            <Button onClick={nextButtonHandler} style={{width:"50%",whiteSpace:"normal", margin:"4px"}}>
                Next <br/> {bucketSize}
            </Button>
        </div>)
}

export default RunningPeriodChartOptions;